<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  // import useValidation from '@/utils/helpers/validations';
  import { useCompanyStore } from "@/stores/company";
import { useSitesStore } from "@/stores/sites";
import { useUiStore } from "@/stores/ui";
import router from "@/router";
  // import moment from "moment-timezone";

  const sitesStore = useSitesStore();
  const uiStore = useUiStore();
  // const { checkEmailValidation } = useValidation();
  const emit = defineEmits(['refresh']);
  const company_id = useCompanyStore().companyId;

  let id = ref(null);
  // let store_id = ref(null);
  let name = ref(null);
  let location = ref(null);
  // let contact_email = ref(null);
  // let timezone = ref(null);
  // let timeZoneNames = ref([]);
  let isValidEmail = ref(true);
  let isSubmitted = ref(false);
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  // S16: the Location->Site mapping is now owned solely by the Integrations
  // workspace. This modal shows a READ-ONLY source summary only; it never
  // writes integration_id / int_store_id. Two mapping writers cannot disagree.
  const sourceSummary = computed(() => {
    const info = getModalInfo.value || {};
    const provider =
      info.integration?.integration_type || info.integration?.provider || null;
    const providerName = info.integration?.name || null;
    const storeName =
      info.integration_store?.store_name ||
      info.integration_store?.provider_name ||
      null;
    if (!provider && !providerName && !storeName) return null;
    return {
      provider: provider || "integration",
      providerName,
      storeName,
    };
  });

  onBeforeMount( async () => {
    // timeZoneNames = moment.tz.names();
    if(getModalInfo.value && getModalInfo.value.data_type == 'site' && getModalAction.value == 'edit_store'){
      id.value = getModalInfo.value.id;
      name.value = getModalInfo.value.name;
      location.value = getModalInfo.value.location;

      // contact_email.value = getModalInfo.value.contact_email;
      // timezone.value = getModalInfo.value.timezone;
    }
  });

  const resetData = () => {
    id.value = null;
    // store_id.value = null;
    name.value = null;
    location.value = null;
    // contact_email.value = null;
    // timezone.value = null;
    isValidEmail.value = true;
    isSubmitted.value = false;
  };

  // const validEmail = () => {
  //   isValidEmail.value = checkEmailValidation(contact_email.value);
  //   return isValidEmail.value;
  // };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  const manageInIntegrations = () => {
    resetStoreData();
    router.push({ name: "IntegrationsView" });
  };

  const onSubmit = () => {
    isSubmitted.value = true;
    // S16: only Site's own attributes are edited here. integration_id /
    // int_store_id are intentionally NOT sent — the Integrations workspace is
    // the sole mapping writer.
    const data = {
      id : id.value,
      // store_id : store_id.value,
      name : name.value,
      // contact_email :contact_email.value,
      // timezone : timezone.value,
      location : location.value,
      company_id
    };

    sitesStore.editSite(data).then(() => {
      resetData();
      resetStoreData();
      emit('refreshSitesArr');
      emit('refresh');
    }).catch( () => {
        isSubmitted.value = false;
    });
  };

  defineExpose({ sourceSummary, manageInIntegrations });
</script>
<template>
  <DModal v-if="getModalAction === 'edit_store'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Site </template>
    
    <template #body>
      <!-- <div class="form-floating mb-3">
        <input v-model.trim="store_id" type="text" class="form-control" id="editStoreId" placeholder="Store ID" />
        <label for="editStoreId">Store ID</label>
      </div> -->

      <div class="mb-3">
        <DInput :value="name" @input="name = $event.target.value" label="Site Name" width="100%" />
      </div>

      <div class="mb-3">
        <DInput :value="location" @input="location = $event.target.value" label="Location" width="100%" />
      </div>

      <!-- <div class="form-floating mb-3"> 
        <input @input="validEmail" v-model="contact_email"  type="email" :class="{'is-invalid' : !isValidEmail}" class="form-control" id="contactEmail" placeholder="Contact Email" />
        <label for="contactEmail">Contact Email</label> 
        <div v-if="!isValidEmail" class="invalid-feedback">
          Invalid Email.
        </div>
      </div> -->

      <!-- <div class="relative"> 
        <span v-if="timezone" class="multiselect-title-span">Time Zone</span>
        <VMultiselect v-model="timezone" :options="timeZoneNames" :disabled="!timeZoneNames.length" :loading="!timeZoneNames.length" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Time Zone"/>
      </div> -->

      <!-- S16: READ-ONLY catalogue source summary. Mapping is managed only in
           the Integrations workspace — this modal is not a mapping writer. -->
      <div class="edit-site-source mb-3" data-test="source-summary">
        <div class="edit-site-source__label">Catalogue source</div>
        <div v-if="sourceSummary" class="edit-site-source__value" data-test="source-value">
          <span class="edit-site-source__provider">{{ sourceSummary.providerName || sourceSummary.provider }}</span>
          <span v-if="sourceSummary.storeName" class="edit-site-source__store">
            · {{ sourceSummary.storeName }}
          </span>
        </div>
        <div v-else class="edit-site-source__value edit-site-source__value--empty" data-test="source-empty">
          No catalogue source linked
        </div>
        <button
          type="button"
          class="edit-site-source__link"
          @click="manageInIntegrations"
          data-test="manage-in-integrations"
        >
          Manage in Integrations
          <i class="bi bi-arrow-right-short"></i>
        </button>
      </div>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!name || !location || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Edit
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>
  </DModal>
</template>

<style lang="scss" scoped>
.edit-site-source {
  border: 1px solid var(--neutral-200);
  border-radius: 10px;
  padding: 12px 14px;
  background: var(--neutral-50);
}
.edit-site-source__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--neutral-500);
  margin-bottom: 4px;
}
.edit-site-source__value { font-size: var(--text-sm); color: var(--neutral-800); }
.edit-site-source__value--empty { color: var(--neutral-400); }
.edit-site-source__provider { font-weight: 600; text-transform: capitalize; }
.edit-site-source__store { color: var(--neutral-500); }
.edit-site-source__link {
  margin-top: 8px;
  background: none;
  border: none;
  padding: 0;
  color: var(--primary-600);
  font-size: var(--text-sm);
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
</style>
